var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _path, _path2, _path3, _path4, _circle, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrontDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 59,
    viewBox: "0 0 76 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.4736,
    y: 11.6631,
    width: 53.625,
    height: 36.0834,
    rx: 3.6894,
    fill: "#F3F4F9",
    stroke: "#0F90FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 34.2998,
    y: 16.9473,
    width: 25.5152,
    height: 3.1894,
    fill: "#C3C6DB"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 34.2998,
    y: 21.7314,
    width: 12.7576,
    height: 1.5947,
    fill: "#C3C6DB"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 34.2998,
    y: 26.5156,
    width: 6.37879,
    height: 1.5947,
    fill: "#C3C6DB"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 34.2998,
    y: 31.2993,
    width: 7.97349,
    height: 1.5947,
    fill: "#C3C6DB"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 43.8672,
    y: 31.2993,
    width: 4.78409,
    height: 1.5947,
    fill: "#C3C6DB"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 19.9473,
    y: 34.4888,
    width: 6.37879,
    height: 1.5947,
    fill: "#C3C6DB"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 18.3525,
    y: 39.2729,
    width: 41.4621,
    height: 3.1894,
    fill: "#C3C6DB"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 16.7578,
    y: 16.9473,
    width: 14.3523,
    height: 15.947,
    fill: "#0F90FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 12.9602V1H9.77084",
    stroke: "#9EA1B9",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M74.7744 12.9602V1H66.0036",
    stroke: "#9EA1B9",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 45.6516V57.6118H9.77084",
    stroke: "#9EA1B9",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M74.7744 45.6516V57.6118H66.0036",
    stroke: "#9EA1B9",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.934,
    cy: 22.5282,
    r: 3.98674,
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.5154 29.1805V31.2993H18.3525V29.1804C19.6681 27.5546 21.6796 26.5151 23.9339 26.5151C26.1883 26.5151 28.1998 27.5546 29.5154 29.1805Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrontDocument);
export default __webpack_public_path__ + "static/media/front-document.d8b9e37e773d589208010f485c76842e.svg";
export { ForwardRef as ReactComponent };